<!--AI量化策略-->
<template>
	<div class="page-body center-wrap">
		<div class="ai-title">
			<div class="left-con">
				<span class="title-name dispalynone">{{ $t('AI量化策略') }}</span>
				{{ $t('当前团队等级') }}
				<span class="num">V{{ aiData.team_level || 0 }}</span>
				<span class="rule cur-poi" @click="$nav.go('/pc/grade')">{{ $t('等级规则') }}</span>
			</div>
			<div class="right-con">
				<div class="cm-input-box">
					<img alt="" src="@/assets/img-pc/118.d1642339.png" class="lazy-img icon-usdt">
					<div class="disabled-input">{{ aiData.total_profit || '0.00' }}USDT{{ $t('策略总收益') }}</div>
				</div>
			</div>
		</div>
		<model1 :list1="aiData.user_ids" :list2="aiData.ai_currency" @openSubmit="open"></model1>
		<model2 :aiData="aiData"></model2>
		<model3 :list="aiData.all_ai_product" @openSubmit="open"></model3>
		<model4></model4>

		<submitDialog ref="submitDialogRef"></submitDialog>
	</div>

</template>
<script>
import { get } from '@/http/request'
import apis from '@/http/api'
import model1 from './components/model1.vue';
import model2 from './components/model2.vue';
import model3 from './components/model3.vue';
import model4 from './components/model4.vue';
import submitDialog from './components/submitDialog.vue';
export default {
	components: {
		model1,
		model2,
		model3,
		model4,
		submitDialog,
	},
	data() {
		return {
			aiData: {}
		};
	},

	created() {
		this.getData()
	},
	methods: {
		getData() {
			get(apis.aiData).then(res => {
				if (res.code != 1) return
				this.aiData = res.data
			})
		},
		open(id) {
			this.$refs.submitDialogRef.open(id)
		}
	},
};
</script>
<style lang="scss" scoped>
.page-body {
	.ai-title {
		height: 43px;
		line-height: 43px;
		display: flex;
		flex-wrap: nowrap;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		margin: 31px auto 20px;

		.right-con {
			.cm-input-box {
				width: 306px;
				height: 50px;
				justify-content: center;
				border-radius: 8px;
				border: 1px solid #1a1b24;
				background: #12141e;
				color: #888;
				padding: 0 20px;
				margin: 0 auto;
				display: flex;
				flex-wrap: nowrap;
				flex-direction: row;
				align-items: center;
				font-size: 14px;

				img {
					margin-right: 10px;
					width: 26px;
					height: 26px;
				}
			}
		}

		.left-con {
			display: flex;
			flex-wrap: nowrap;
			flex-direction: row;
			align-items: center;
			justify-content: normal;

			.title-name {
				font-size: 24px;
				margin-right: 20px;
			}

			.num {
				margin-left: 10px;
				color: #f7931a;
			}

			.rule {
				color: #00f0ff;
				margin-left: 10px;
			}
		}
	}
}
</style>